// NFC is not available to web pages, report it as unsupported.
export default {
  isSupported: () => Promise.resolve(false),
  isEnabled: () => Promise.resolve(false),
  start: () => Promise.reject(new Error("NFC is not supported on web")),
  registerTagEvent: () => Promise.resolve(),
  unregisterTagEvent: () => Promise.resolve(),
};
